import { render, staticRenderFns } from "./EditMessages.vue?vue&type=template&id=0a9e5800&scoped=true"
import script from "./EditMessages.vue?vue&type=script&lang=js"
export * from "./EditMessages.vue?vue&type=script&lang=js"
import style0 from "./EditMessages.vue?vue&type=style&index=0&id=0a9e5800&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9e5800",
  null
  
)

export default component.exports